/**
 * One Dialog for every screen: a bottom sheet on phones, a centered modal on desktop. It replaces
 * the react-device-detect branches (Drawer vs Dialog), which rendered a different tree on the
 * server than on a phone and caused hydration mismatches.
 */
export const REVIEW_SHEET_CLASS =
    'flex flex-col gap-3 bg-bg text-right dark:bg-primary-active dark:border-white/15 p-4 lg:p-5 lg:h-[85vh] lg:min-w-[70vw] lg:rounded-xl max-lg:top-auto max-lg:bottom-0 max-lg:translate-y-0 max-lg:h-[92vh] max-lg:max-w-none max-lg:rounded-t-2xl max-lg:rounded-b-none';
